import { Button } from "@components/shared/core/Button";
import { Link } from "@components/shared/core/Link";
import ArrowIcon from "@hawkins/assets/lib/icons/iconArrowUpRight";
import { useIsDesktop } from "@hooks/useIsDesktop";

type CtaButtonProps = {
  ctaText: string;
  ctaLink: string;
  variant?: "text" | "light-on-true" | "light-on-blur" | "current-on-blur" | "dark-on-light";
  className?: string;
  showArrowOnMobile?: boolean;
  onClick?: () => void;
};

export const CtaButton = ({ 
  ctaText, 
  ctaLink, 
  variant = "light-on-blur",
  className = "",
  showArrowOnMobile = false,
  onClick
}: CtaButtonProps) => {
  const isDesktop = useIsDesktop();

  if (!isDesktop && showArrowOnMobile) {
    return (
      <Button asChild className={`w-full ${className}`}>
        <Link href={ctaLink} onClick={onClick}>
          <div className="flex items-center gap-2">
            <span>{ctaText}</span>
            <ArrowIcon size="small" />
          </div>
        </Link>
      </Button>
    );
  }

  return (
    <Button asChild variant={variant} className={className}>
      <Link href={ctaLink} onClick={onClick}>
        {ctaText}
      </Link>
    </Button>
  );
};
